import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { MdDelete } from "react-icons/md";
import { TiDelete, TiPlus } from "react-icons/ti";
import { useGlobalContext } from "../../Context/GlobalContext";
import { getCurrentDate } from "../../Utilitie";

import axios from "axios";
import Loading from "../../Extra/Loading";
import CreateDemand from "./CreateDemand";
import DemandTable from "./DemandTable";

const DemandIns = ({ stationData, itemData }) => {
  const [stationId, setStationId] = useState(null);
  const createEntry = () => ({
    "Sr No.": null,
    item_id: null,

    requested_qty: null,
    remarks: null,

    document: null,
    status: "PENDING",

    delete: null,
  });

  const { userData } = useGlobalContext();
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [selectedRow, setSelectedRow] = useState(null);
  const [entries, setEntries] = useState([createEntry()]);
  const [updateData, setUpdateData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const keys = [
    "Sr No.",
    "item_id",

    "requested_qty",
    "remarks",

    "document",
    "status",

    "delete",
  ];
  const inputStyle = {
    // background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };
  const selectStyle = {
    width: "130px",
    background: "#e1dde9",
    color: "#5c5666",
    border: "2px solid #fafafa",
    borderRadius: "10px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "0.8rem",
  };

  // Get stationId from stationData
  useEffect(() => {
    if (!userData || !stationData.length) return;

    const station = stationData.find(
      (item) => item.station_code === userData.stn,
    );

    if (station) {
      setStationId(station.station_id);
    }
  }, [userData, stationData]);

  // Fetch data
  const fetchData = async () => {
    if (!stationId) return;

    setLoading(true);
    setError(false);

    try {
      const url = `${urlPrefix}getDynamicDataForTwoDate?table_name=m_store_demand&station_id=${stationId}`;

      const response = await axios.get(url);

      if (response.data.success) {
        const data = response.data.data || [];

        setUpdateData(data);

        // Initialize entries only after API response
        setEntries(
          data.map((item) => ({
            ...item,
            isEdited: false,
          })),
        );
      } else {
        setUpdateData([]);
        setEntries([]);
      }
    } catch (err) {
      console.error("Failed to fetch data:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  // Fetch whenever stationId changes
  useEffect(() => {
    if (stationId) {
      fetchData();
    }
  }, [stationId]);
  // useEffect(() => {
  //   if (userData) {
  //     stationData.forEach((o) => {
  //       if (o.station_code === userData.stn) {
  //         setStationId(o.station_id);
  //       }
  //     });
  //   }
  // }, [userData, stationData]);
  // const fetchData = async () => {
  //   setLoading(true);
  //   try {
  //     const url = `${urlPrefix}getDynamicDataForTwoDate?table_name=m_store_demand&station_id=${stationId}`;

  //     const response = await axios.get(url);

  //     if (response.data.success === true) {
  //       setUpdateData(response.data.data);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Failed to fetch stations:", error);
  //     setLoading(false);
  //     setError(true);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, [stationId]);

  // useEffect(() => {
  //   if (!updateData || !Array.isArray(updateData)) return;

  //   const formattedData = updateData.map((item) => ({
  //     ...item,
  //     isEdited: false,
  //   }));

  //   setEntries(formattedData);
  // }, [updateData]);

  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) =>
        i === rowIndex
          ? {
              ...row,
              [key]: value,
              isEdited: true,
            }
          : row,
      ),
    );
  };
  const addRow = () => {
    // setEntries((prev) => [...prev, createEntry()]);
    setEntries((prev) => [createEntry(), ...prev]);
  };
  const removeRow = (index) => {
    setEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    const editedRows = entries.filter((row) => row.isEdited);

    if (editedRows.length === 0) {
      toast.error("No changes found");
      return;
    }

    const updateRows = editedRows.filter((row) => row.id);

    const insertRows = editedRows.filter((row) => !row.id);

    try {
      if (updateRows.length) {
        const updatePayload = {
          table_name: "m_store_demand",
          rows: updateRows.map((entry) => ({
            id: entry.id,
            updates: {
              station_id: stationId,
              item_id: entry.item_id,
              requested_qty: entry.requested_qty,
              remarks: entry.remarks,

              // updated_by: userData.id,
            },
          })),
        };

        const updateRes = await fetch(`${urlPrefix}updateAllMasterData`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        });

        if (!updateRes.ok) {
          const err = await updateRes.json();
          throw new Error(err.message || "Update failed");
        }
      }

      ///////////////
      if (insertRows.length > 0) {
        for (const entry of insertRows) {
          try {
            const formdata = new FormData();

            formdata.append("station_id", String(stationId));
            formdata.append("item_id", String(entry.item_id));
            formdata.append("requested_qty", String(entry.requested_qty));
            formdata.append("remarks", entry.remarks || "");
            formdata.append("requested_by", 3 || "");
            formdata.append("required_by_date", getCurrentDate());

            // PDF FILE
            if (entry.document instanceof File) {
              formdata.append("document", entry.document, entry.document.name);
            }

            // console.log("Uploading:", {
            //   station_id: stationId,
            //   item_id: entry.item_id,
            //   requested_qty: entry.requested_qty,
            //   required_by_date: entry.required_by_date,
            //   requested_by: entry.requested_by,
            //   remarks: entry.remarks,
            //   document: entry.document,
            // });

            // Optional: see exactly what is being sent
            // for (const [key, value] of formdata.entries()) {
            //   console.log(
            //     key,
            //     value instanceof File
            //       ? {
            //           name: value.name,
            //           type: value.type,
            //           size: value.size,
            //         }
            //       : value,
            //   );
            // }

            const insertRes = await fetch(`${urlPrefix}store/create_demand`, {
              method: "POST",
              body: formdata,
              redirect: "follow",
            });

            const result = await insertRes.text();

            if (!insertRes.ok) {
              throw new Error(
                result || `Demand insert failed (${insertRes.status})`,
              );
            }

            console.log("Demand created successfully:", result);
          } catch (error) {
            console.error("Demand insert error:", error);
            throw error;
          }
        }
      }
      /////////////
      toast.success("Saved successfully");

      fetchData();
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };
  return (
    <div className="container-fluid mt-3">
      {loading && <Loading />}

      {/* <h4 className="bg-dark text-white p-2 text-center">Demand </h4> */}
      <CreateDemand stationData={stationData} itemData={itemData} />
      <DemandTable data={updateData} />
      <div className="d-flex justify-content-center">
        <select
          className="form-select-sm shadow m-2"
          style={selectStyle}
          value={stationId}
          onChange={(e) => setStationId(Number(e.target.value))}
        >
          {/* <option>Select </option>{" "} */}
          <option>select</option>
          {userData.stn &&
            stationData

              // .filter((item) => item.station_code === userData.stn)
              .map((item) => (
                <option key={item.station_id} value={item.station_id}>
                  {item.station_code}
                </option>
              ))}
        </select>

        <button
          className="btn btn-dark btn-sm"
          onClick={(e) => {
            e.currentTarget.disabled = true;
            addRow();
          }}
        >
          Add Demand
        </button>
      </div>

      <div className="table-responsive" style={{ maxHeight: "700px" }}>
        <table className="table table-bordered" style={{ fontSize: "12px" }}>
          <thead className="border table-dark  ">
            <tr className="sticky-top">
              {keys.map((key) => (
                <th key={key}>{key.replaceAll("_", " ").toUpperCase()}</th>
              ))}
            </tr>
          </thead>
          <tbody className="    ">
            {entries.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <tr
                  onClick={() => setSelectedRow(rowIndex)}
                  style={{
                    cursor: "pointer",
                    border: selectedRow === rowIndex ? "3px solid #b69bee" : "",
                  }}
                >
                  {keys.map((key) => (
                    <td key={key} className="p-1 m-0">
                      {key === "Sr No." ? (
                        <h1 class="badge text-bg-dark p-2">{rowIndex + 1}</h1>
                      ) : key === "delete" ? (
                        !row.id ? (
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => removeRow(rowIndex)}
                          >
                            &times;
                          </button>
                        ) : null
                      ) : key === "remarks" ? (
                        <input
                          disabled={row.id && row[key]}
                          type="text"
                          className=" form-select-sm shadow"
                          style={{
                            ...inputStyle,
                            width: "250px",
                            background: "#e1dde9",
                            borderColor: row[key] ? "#d0c4e7" : "white",
                          }}
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "status" ? (
                        <div className=" d-flex justify-content-center">
                          <div
                            className=" p-1 shadow"
                            style={{
                              ...inputStyle,
                              width: "210px",
                              background:
                                row[key] === "COMPLETED"
                                  ? "#b7e6a1"
                                  : row[key] === "PENDING"
                                    ? "#e5e6b0"
                                    : row[key] === "APPROVED"
                                      ? "#93bbdb"
                                      : row[key] === "PARTIALLY_ISSUED"
                                        ? "#e2ba8b"
                                        : row[key] === "REJECTED"
                                          ? "#ec9c97"
                                          : null,
                            }}
                            value={row[key] ? row[key]?.slice(0, 10) : null}
                            onChange={(e) =>
                              handleChange(rowIndex, key, e.target.value)
                            }
                          >
                            {row[key]}
                          </div>
                        </div>
                      ) : key === "item_id" ? (
                        <select
                          disabled={row.id && row[key]}
                          className="form-select-sm shadow"
                          style={{
                            ...selectStyle,
                            borderColor: row[key] ? "#d0c4e7" : "white",
                          }}
                          value={row[key] ?? ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, Number(e.target.value))
                          }
                        >
                          <option value="">Select</option>

                          {itemData.map((item) => (
                            <option key={item.item_id} value={item.item_id}>
                              {item.item_name}
                            </option>
                          ))}
                        </select>
                      ) : key === "document" ? (
                        <div className="d-flex  justify-content-center shadow ">
                          <input
                            style={{
                              ...inputStyle,
                              width: "220px",
                              background: "#e1dde9",
                              borderColor: row[key] ? "#d0c4e7" : "white",
                            }}
                            type="file"
                            accept=".pdf"
                            className={`form-control form-control-sm ${
                              row[key] ? "border-success" : "border-warning"
                            }`}
                            onChange={(e) => {
                              const f = e.target.files?.[0];
                              if (!f) return;
                              if (
                                f.type !== "application/pdf" ||
                                f.size > 200 * 1024
                              )
                                return alert("Only PDF up to 200 KB allowed");
                              handleChange(rowIndex, key, f);
                            }}
                          />

                          {row[key] && (
                            <>
                              <button
                                type="button"
                                className="ms-3 btn btn-sm btn-primary rounded-pill"
                                onClick={() =>
                                  window.open(
                                    typeof row[key] === "string"
                                      ? row[key]
                                      : URL.createObjectURL(row[key]),
                                    "_blank",
                                  )
                                }
                              >
                                📄
                              </button>
                            </>
                          )}

                          {!row[key] && (
                            <small className="text-muted mt-3">
                              Max 200 KB
                            </small>
                          )}
                        </div>
                      ) : (
                        <input
                          disabled={row.id && row[key]}
                          type="number"
                          className=" form-select-sm shadow"
                          style={{
                            ...inputStyle,
                            width: "110px",
                            background: "#e1dde9",
                            borderColor: row[key] ? "#d0c4e7" : "white",
                          }}
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      )}
                    </td>
                  ))}
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center">
        <button className="btn btn-success" onClick={handleSubmit}>
          Save
        </button>
      </div>
    </div>
  );
};

export default DemandIns;
